import React, { useEffect } from 'react';
import { Box, Container, Typography, Paper, Divider } from '@mui/material';

const Section = ({ title, children }) => (
  <Box sx={{ mb: 4 }}>
    <Typography variant="h6" sx={{ fontWeight: 700, color: '#1B1464', mb: 1.5, fontSize: { xs: '1rem', md: '1.25rem' } }}>
      {title}
    </Typography>
    {children}
  </Box>
);

const Para = ({ children }) => (
  <Typography variant="body2" sx={{ color: '#444', lineHeight: 1.9, mb: 1.5, fontSize: { xs: '0.85rem', md: '0.95rem' } }}>
    {children}
  </Typography>
);

const TermsAndConditions = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box sx={{ backgroundColor: '#FBF9F7', minHeight: '100vh', py: { xs: 3, md: 6 } }}>
      <Container maxWidth="md">
        <Typography
          variant="h3"
          sx={{
            textAlign: 'center',
            fontWeight: 700,
            color: '#1A1A2E',
            mb: 1,
            fontSize: { xs: '1.6rem', sm: '2rem', md: '2.5rem' },
          }}
        >
          Terms & Conditions
        </Typography>

        <Paper sx={{ p: { xs: 3, md: 5 }, borderRadius: 2, boxShadow: '0 4px 20px rgba(0,0,0,0.06)' }}>
          <Para>
            By accessing or using vallivelimaligai.in ("Website"), you agree to these Terms. If you do not agree, please do not use our Website.
          </Para>

          <Divider sx={{ my: 3 }} />

          <Section title="1. Eligibility">
            <Para>
              You must be at least 18 years old to use this Website or make a purchase.
            </Para>
          </Section>

          <Section title="2. Products and Pricing">
            <Para>
              • Products are subject to availability and may be discontinued without notice.<br />
              • Prices are in INR and may vary based on silver market rates.<br />
              • Product images are for reference; actual appearance may vary slightly.
            </Para>
          </Section>

          <Section title="3. Orders and Payment">
            <Para>
              • We reserve the right to accept or decline any order.<br />
              • Payments are processed through secure payment gateways. We do not store card details.
            </Para>
          </Section>

          <Section title="4. Shipping">
            <Para>
              • Orders are dispatched within 2–5 business days.<br />
              • Delivery timelines depend on location. We are not liable for courier delays.
            </Para>
          </Section>

          <Section title="5. Returns">
            <Para>
              • Returns accepted within 7 days if the product is unused with original packaging.<br />
              • Customized items are non-returnable.
            </Para>
          </Section>

          <Section title="6. Intellectual Property">
            <Para>
              All content on this Website is the property of Valli Velli Maligai and may not be reproduced without written consent.
            </Para>
          </Section>

          <Section title="7. Limitation of Liability">
            <Para>
              We are not liable for indirect or consequential damages arising from use of the Website.
            </Para>
          </Section>

          <Section title="8. Governing Law">
            <Para>
              These Terms are governed by the laws of India. Disputes are subject to the jurisdiction of courts in Karur, Tamil Nadu.
            </Para>
          </Section>

          <Section title="9. Changes">
            <Para>
              We may update these Terms at any time. Continued use of the Website constitutes acceptance of changes.
            </Para>
          </Section>

          <Section title="10. Contact Us">
            <Para>
              <strong>Valli Velli Maligai</strong><br />
              Vengamedu, Karur District, Tamil Nadu, India<br />
              Phone: +91 6382939365<br />
              Email: info@vallivelli.com
            </Para>
          </Section>
        </Paper>
      </Container>
    </Box>
  );
};

export default TermsAndConditions;
